export default __webpack_public_path__ + "static/media/successpayment.4834f19e.svg";